'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextElementType = require('./TextElementType');

var _TextElementType2 = _interopRequireDefault(_TextElementType);

var _TagElementType = require('./TagElementType');

var _TagElementType2 = _interopRequireDefault(_TagElementType);

var _StyleElementType = require('./StyleElementType');

var _StyleElementType2 = _interopRequireDefault(_StyleElementType);

var _UnsupportedElementType = require('./UnsupportedElementType');

var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Node} node
 */
/*
 * Map each element type to a function which will convert that element type to a React element
 * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
 * value
 */

exports.default = function (node) {
  if (node.nodeName === 'SCRIPT') {
    return _UnsupportedElementType2.default;
  }
  if (node.nodeName === 'STYLE') {
    return _StyleElementType2.default;
  }
  switch (node.nodeType) {
    case Node.TEXT_NODE:
      return _TextElementType2.default;
    case Node.ELEMENT_NODE:
      return _TagElementType2.default;
    default:
      return _UnsupportedElementType2.default;
  }
};